import axios from 'axios';
import getters from '@/store/getters';
import {
  _getUserKey,
  _getConnectionRecord,
  _getApiCount,
  _addNewUserKey,
  _getAvailableKey,
  _deleteUserKey,
  _getApiRecord,
  _getActivedUser
} from './ffi';
import {_addPaymentModule, _deletePaymentModules, _getAllPaymentModules} from './paymentMoudleAdmin';
import {_dateMarkDelete, _getMigrationImages} from './migrationApi';
import {
  _changeCustomModule,
  _getAllMachineList,
  _getApimoduleList,
  _getClientAppList,
  _getCurrentVersionList,
  _getCurretnVersion,
  _getCustomMachine,
  _getDishModelList,
  _getFoodModelList,
  _getRegionModelList,
  _publishApiModule,
  _publishClientApp,
  _publishDishModel,
  _publishFoodModel,
  _publishRegionModel,
  _pullFoodModel,
  _queryModulePublishMachine,
  _uploadApiZip,
  _uploadMainClient
} from './moduleApi';

import {
  _deleteImage,
  _emitZipTask,
  _fixRegions,
  _getAllRegionLabelTask,
  _getAllRegionModels,
  _getAllTaskList,
  _getAllZipTask,
  _getDetailByLabelTaskId,
  _getPreMarkTaskDetails,
  _getReasonCount,
  _getRegionCheckData,
  _getRegionImages,
  _hello,
  _imageUploadForRegion,
  _regionCheck,
  _regionFixDone,
  _regionImageRandomGetByTaskId,
  _regionLabelCancelCheck,
  _regionModelChheckByLabelTask,
  _regionModelPreMark,
  _regionModelPublish,
  _sendLabelTaskList,
  _setStandard,
  _uploadimageFromBatch,
  _uploadRegionModel,
  _getAllCategoryList,
  _addCategory,
  _getCategoryCount,
  _updateCategoryTarget,
  _generateZip,
  _setCommonRegionModel,
  _getZipTaskProgress
} from './regionApi';

import {
  _getAllCanteen,
  _getCanteenList,
  _getEateryList,
  _getMachineList,
  _machineUseInfo,
  _requestLogin,
  _setLanCanteen
} from './loginApi';

import {
  _baseModelList,
  _batchAddImages,
  _cancelCheck,
  _getbackDataByCanteen,
  _getCheckedImgByTaskId,
  _getCollectInference,
  _getDetailByModelId,
  _getImageByUUID,
  _getImgByUuid,
  _getImgByUuidList,
  _getMarkDataCount,
  _getServerPointList,
  _getTask,
  _getTaskHistory,
  _getTaskListBeforeNewTask,
  _getTrainedImages,
  _getTrainedModelList,
  _getTrainTaskList,
  _historyTaskRemark,
  _newTask,
  _register,
  _selectTrainAcc,
  _setTaskTrainable,
  _setTaskUrgent,
  _stopTask
} from './taskApi';
import {
  _addClass,
  _addClassDishToCanteen,
  _checkFailDishes,
  _checkModel,
  _checkPassDishes,
  _classifyQuery,
  _combineDishes,
  _confirmDeleteClass,
  _copyClassDish,
  _deleteClass,
  _deleteDishModel,
  _deleteRelatedClass,
  _editCanteenClass,
  _editClassDish,
  _getAllClassList,
  _getBindCanteenListByClassId,
  _getClassDishByClassId,
  _getImgCountByClassId,
  _getMarkedImagesByClassId,
  _imageCollect,
  _queryAllCachedDishes,
  _queryCanteenClassList,
  _queryTaskByCanteen,
  _trainModelCheckResult
} from './modelApi';
import {
  _batchChange,
  _changeBatchState,
  _getBatchImageList,
  _getBatchList,
  _markBatchImages,
  _regionImgByUuid
} from './dataMarkApi';

import {
  _backDataAccSave,
  _backDataCheckRemind,
  _backDataMark,
  _checkDetectedImage,
  _dateCollectCheckRemind,
  _detectedCheckRemind,
  _getAccByCanteen,
  _getBackData,
  _getBackDataAcc,
  _getDetectedImage,
  _getLabelTaskidByBar,
  _getResentlyAcc
} from './analysisApi';
import {_getAllEvents, _newestTs, _queryEventsByMachineId, _getManualPersant} from './evnetApi';
import {_getImageRegions} from './imageClip';
import {_deleteUser, _editPermissions, _editUser, _getAllUserList, _getUserPermissions, _registerNewUser} from './user';
import _ from "lodash";
import qs from "querystring";
import encrypt from "@/api/encrypt";

const api_key = getters.userinfo().api_key;
// import {HttpRequest} from './axios';

// http://47.99.142.73:7706
// 'http://121.41.92.64:7706'
// console.log(process.env.VUE_APP_SERVER_TYPE);
let baseUrl = '';
if (process.env.VUE_APP_SERVER_TYPE === "dev") {
  baseUrl = "http://47.99.142.73:7706";
} else {
  baseUrl = 'http://121.41.92.64:7706';
}
export const httpClient = axios.create({
  baseURL: baseUrl,
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 180000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
export const httpClientRegion = axios.create({
  // baseURL: baseUrl.replace(/(\d+$)/g, 7001),
  baseURL: baseUrl.replace(/(\d+$)/g, 9052),
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 60000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
export const httpClient9051 = axios.create({
  baseURL: baseUrl.replace(/(\d+$)/g, 9051),
  headers: {
    "api-key": api_key
    // Accept:
    //   "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8"
  }
});
// 主要用来添加账号
export const httpClient1 = axios.create({
  baseURL: baseUrl.replace(/(\d+$)/g, 7705),
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 60000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
console.log(baseUrl.replace(/(\d+$)/g, 7001));
export const httpClient2 = axios.create({
  baseURL: baseUrl.replace(/(\d+$)/g, 7001),
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 60000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
export const httpClient3 = axios.create({
  baseURL: baseUrl.replace(/(\d+$)/g, 33311),
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 60000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
export const httpMockClient = axios.create({
  baseURL: `https://easy-mock.com/mock/5cb45922136f8104033407b1/`,
  // baseURL: 'http://121.41.92.64:7706',
  timeout: 60000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8",
    "api-key": api_key
  }
});
export const ffiClient = axios.create({
  baseURL: 'https://ffi.zhihuituancan.com',
  // baseURL: 'http://192.168.2.179:7766',
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/json,;q=0.9,image/webp,*/*;q=0.8"
  }
});

httpClient.interceptors.request.use(
  config => {
    console.log(config);
    console.log("请求内容: \n" + config.url + JSON.stringify(config.data));
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
httpClient.interceptors.response.use(
  res => {
    console.log(res);
    return res;
  },
  err => Promise.reject(err)
);
export const handleError = err => {
  if (err.response) {
    console.log(err.response.status);
    console.log(err.response.headers);
  } else if (err.request) {
    console.log(err.request);
  } else {
    console.log("Error", err.message);
  }
};
export const apiRequestLogin = _requestLogin;
export const apiGetEateryList = _getEateryList;
export const apiGetCanteenList = _getCanteenList;
export const apiBaseModelList = _baseModelList;
export const apigetDetailByModelId = _getDetailByModelId;
export const apiBatchAddImages = _batchAddImages;
export const apiRegister = _register;
export const apiGetBackData = _getBackData;
export const apiGetDetectedImage = _getDetectedImage;
export const apiCheckDetectedImage = _checkDetectedImage;
export const apiBackDataMark = _backDataMark;
export const apiBackDataAccSave = _backDataAccSave;
export const apiGetBackDataAcc = _getBackDataAcc;
export const apiDetectedCheckRemind = _detectedCheckRemind;
export const apiBackDataCheckRemind = _backDataCheckRemind;
export const apiDateCollectCheckRemind = _dateCollectCheckRemind;
// 通过classid随机获取20张图片
export const apiGetMarkedImagesByClassId = _getMarkedImagesByClassId;

// export const apiBackDataMark = _;

// 获取所有class
export const apiGetAllClassList = _getAllClassList;
// 获取餐厅class
export const apiQueryCanteenClassList = _queryCanteenClassList;
export const apiImageCollect = _imageCollect;

export const apiDeleteDishModel = _deleteDishModel;
// export const apiAddClassDish = _addClassDish;
export const apiAddClassDishToCanteen = _addClassDishToCanteen;
export const apiDeleteRelatedClass = _deleteRelatedClass;
export const apiCheckPassDishes = _checkPassDishes;
export const apiCheckFailDishes = _checkFailDishes;

export const apiEditClassDish = _editClassDish;
export const apiGetImageByUUID = _getImageByUUID;
export const apiGetMarkDataCount = _getMarkDataCount;
export const apiStopTask = _stopTask;
export const apiGetTask = _getTask;
export const apiNewTask = _newTask;
export const apiSelectTrainAcc = _selectTrainAcc;
export const apiGetTrainedImages = _getTrainedImages;

export const apiGetTrainedModelList = _getTrainedModelList;
export const apiGetBatchImageList = _getBatchImageList;
export const apiGetBatchList = _getBatchList;
export const apiBatchChange = _batchChange;
export const apiAddClass = _addClass;
export const apiConfirmDeleteClass = _confirmDeleteClass;
export const apiDeleteClass = _deleteClass;
export const apiEditCanteenClass = _editCanteenClass;

export const apiMarkBatchImages = _markBatchImages;
export const apiGetMachineList = _getMachineList;
export const apiChangeBatchState = _changeBatchState;

export const apiQueryEventsByMachineId = _queryEventsByMachineId;
export const apiGetAllEvents = _getAllEvents;
export const apiNewestTs = _newestTs;
export const apiQueryAllCachedDishes = _queryAllCachedDishes;

export const apiGetImageRegions = _getImageRegions;

export const apiGetAllUserList = _getAllUserList;
export const apiRegisterNewUser = _registerNewUser;
export const apiDeleteUser = _deleteUser;
export const apiEditUser = _editUser;

// 获取全部餐厅
export const apiGetAllCanteen = _getAllCanteen;
export const apiMachineUseInfo = _machineUseInfo;

// 通过小图获取大图和区域
export const apiGetRegionImgByUuid = _regionImgByUuid;
// 校验训练出的模型
export const apiCheckModel = _checkModel;

export const apiGetbackDataByCanteen = _getbackDataByCanteen;
// 合并碗碟
export const apiCombineDishes = _combineDishes;
// 通过class_id查询图片个数
export const apiGetImgCountByClassId = _getImgCountByClassId;
export const apiGetCollectInference = _getCollectInference;
// 通过classid查询标准classDish
export const apiGetClassDishByClassId = _getClassDishByClassId;
// 取消审查
export const apiCancelCheck = _cancelCheck;
// 获取任务历史
export const apiGetTaskHistory = _getTaskHistory;
// 获取历史人物的详细信息
export const apiGetCheckedImgByTaskId = _getCheckedImgByTaskId;
// 通过uuid查询图片
export const apiGetImgByUuid = _getImgByUuid;
// 获取正在运行的训练任务列表
export const apiGetTrainTaskList = _getTrainTaskList;
// copy碗碟
export const apiCopyClassDish = _copyClassDish;
// 设置任务加急
export const apiSetTaskUrgent = _setTaskUrgent;
// 获取节点数据
export const apiGetServerPointList = _getServerPointList;
// 新建任务前获取任务历史列表
export const apiGetTaskListBeforeNewTask = _getTaskListBeforeNewTask;
// 历史重新标注
export const apiHistoryTaskRemark = _historyTaskRemark;
// 某任务是否可用于训练
export const apiSetTaskTrainable = _setTaskTrainable;
// 查询检测结果
export const apiTrainModelCheckResult = _trainModelCheckResult;
// 通过class_id获取餐厅列表
export const apiGetBindCanteenListByClassId = _getBindCanteenListByClassId;
// 查询餐厅下的任务信息
export const apiQueryTaskByCanteen = _queryTaskByCanteen;
// 添加支付模块
export const apiAddPaymentModule = _addPaymentModule;
// 获取全部支付插件
export const apiGetAllPaymentModules = _getAllPaymentModules;
// 删除支付模块
export const apiDeletePaymentModules = _deletePaymentModules;
// 获取餐厅的摩天的准确率
export const apiGetAccByCanteen = _getAccByCanteen;
// 获取7天的准确率
export const apiGetResentlyAcc = _getResentlyAcc;
// 上传regionModel
export const apiUploadRegionModel = _uploadRegionModel;
// hellow
// export const hello = _hello;
// 获取全部 regionModle
export const apiGetAllRegionModels = _getAllRegionModels;
// 批量上传大图
export const apiImageUploadForRegion = _imageUploadForRegion;
// 获取全部大图
export const apiGetAllRegionLabelTask = _getAllRegionLabelTask;
// 从书生获取图片
export const apiGetRegionImages = _getRegionImages;
// 随机获取一张大图
export const apiRegionImageRandomGetByTaskId = _regionImageRandomGetByTaskId;
// 模型检测
export const apiRegionModelChheckByLabelTask = _regionModelChheckByLabelTask;
// 点击条形图获取批次
export const apiGetLabelTaskidByBar = _getLabelTaskidByBar;
// 获取权限
export const apiGetUserPermissions = _getUserPermissions;
export const apiEditUserPermissions = _editPermissions;
// 根据uuid列表回去图片信息
export const apiGetImgByUuidList = _getImgByUuidList;
// 预标注或者检测
export const apiRegionModelPreMark = _regionModelPreMark;
// 局偶去所有任务
export const apiGetAllTaskList = _getAllTaskList;
// 从碗碟批次获取图片
export const apiUploadimageFromBatch = _uploadimageFromBatch;
// 获取迁移图片
export const apiGetMigrationImages = _getMigrationImages;
// 清洗迁移数据
export const apiDateMarkDelete = _dateMarkDelete;
// 获取预标任务详细信息
export const apiGetPreMarkTaskDetails = _getPreMarkTaskDetails;
// 获取检测任务详情
export const apiGetRegionCheckData = _getRegionCheckData;
// 人工修改
export const apiFixRegions = _fixRegions;
// 模型检测
export const apiRegionCheck = _regionCheck;
// 一批检测完成
export const apiRegionFixDone = _regionFixDone;
// 获取所有的类别
export const apiGetAllCategoryList = _getAllCategoryList;
// 添加类别列表
export const apiAddCategory = _addCategory;
// 设为标准模型
export const apiSetStandard = _setStandard;
export const apiGetDetailByLabelTaskId = _getDetailByLabelTaskId;
export const apiEmitZipTask = _emitZipTask;
export const apiGetAllZipTask = _getAllZipTask;
export const apiRegionModelPublish = _regionModelPublish;
export const apiRegionLabelCancelCheck = _regionLabelCancelCheck;
export const apiSendLabelTaskList = _sendLabelTaskList;
// 上传主客户端
export const apiUploadMainClient = _uploadMainClient;
// 获取机器列表
export const apiGetAllMachineList = _getAllMachineList;
export const apiPublishClientApp = _publishClientApp;
export const apiChangeCustomModule = _changeCustomModule;
export const apiGetCustomMachine = _getCustomMachine;
export const apiGetClientAppList = _getClientAppList;
export const apiUploadApiZip = _uploadApiZip;
export const apiGetApiModuleList = _getApimoduleList;
export const apiPublishApiModule = _publishApiModule;
export const apiGetRegionModelList = _getRegionModelList;
export const apiPublishRegionModel = _publishRegionModel;
export const apiGetFoodModelList = _getFoodModelList;
export const apiPublishFoodModel = _publishFoodModel;
export const apiPullFoodModel = _pullFoodModel;
export const apiPublishDishModel = _publishDishModel;
export const apiGetDishModelList = _getDishModelList;
export const apiGetCurretnVersion = _getCurretnVersion;
export const apiGetCurrentVersionList = _getCurrentVersionList;
export const apiGetReasonCount = _getReasonCount;
export const apiDeleteImage = _deleteImage;
export const apiSetLanCanteen = _setLanCanteen;
export const apiQueryModulePublishMachine = _queryModulePublishMachine;
export const apiClassifyQuery = _classifyQuery;
export const apiUpdateCategoryTarget = _updateCategoryTarget;
export const apiGetCategoryCount = _getCategoryCount;
export const apiGenerateZip = _generateZip;
export const apiSetCommonRegionModel = _setCommonRegionModel;
export const apiGetManualPersant = _getManualPersant;
export const apiGetZipTaskProgress = _getZipTaskProgress;
export const apiGetUserKey = _getUserKey;
export const apiGetConnectionRecord = _getConnectionRecord;
export const apiGetApiCount = _getApiCount;
export const apiGetAvailableKey = _getAvailableKey;
export const apiAddNewUserKey = _addNewUserKey;
export const apiDeleteUserKey = _deleteUserKey;
export const apiGetApiRecord = _getApiRecord;
export const apiGetActivedUser = _getActivedUser;

ffiClient.interceptors.request.use(config => {
  let request_params = _.cloneDeep(config.params);
  let request_url = config.url
  console.log(request_params);
  if (request_params) {
    request_url = config.url + '?' + qs.stringify(request_params);
  }
  console.log('加密前: ', request_url);
  request_url = encrypt(request_url)
  console.log('加密后: ', request_url);
  config.headers['signature'] = request_url
  // config.params = {}
  return config
})
